/*
This software is Copyright ©️ 2020 The University of Southern California. All Rights Reserved. 
Permission to use, copy, modify, and distribute this software and its documentation for educational, research and non-profit purposes, without fee, and without a written agreement is hereby granted, provided that the above copyright notice and subject to the full license file found in the root of this software deliverable. Permission to make commercial use of this software may be obtained by contacting:  USC Stevens Center for Innovation University of Southern California 1150 S. Olive Street, Suite 2300, Los Angeles, CA 90115, USA Email: accounting@stevens.usc.edu

The full terms of this copyright and license should always be found in the root directory of this software deliverable as "license.txt" and if these terms are not found with this software, please contact the USC Stevens Center for the full license.
*/
import React from 'react';
import PencilIcon from '@mui/icons-material/Edit';
import LightbulbIcon from '@mui/icons-material/Lightbulb';
import DefaultIcon from '@mui/icons-material/Interests';
import PencilOutline from '@mui/icons-material/DriveFileRenameOutline';
export enum DisplayIcons {
  LIGHT_BULB = 'LIGHT_BULB',
  PENCIL = 'PENCIL',
  PENCIL_OUTLINE = 'PENCIL_OUTLINE',
  DEFAULT = 'DEFAULT',
}

export const DisplayIcon = (props: {
  iconName: DisplayIcons;
  style?: React.CSSProperties;
}): JSX.Element => {
  switch (props.iconName) {
    case DisplayIcons.LIGHT_BULB:
      return <LightbulbIcon style={props.style} />;
    case DisplayIcons.PENCIL:
      return <PencilIcon style={props.style} />;
    case DisplayIcons.PENCIL_OUTLINE:
      return <PencilOutline style={props.style} />;
    case DisplayIcons.DEFAULT:
      return <DefaultIcon style={props.style} />;
    default:
      return <> </>;
  }
};
